import { Request } from "@tools/base";;
const { Axios } = Request;

const URL = "/v1/user/";

//获取用户vip信息
export function get_privateUserVipInfo(config?) {
  return Axios.get(URL + `private/userVip/info`, config);
}
//获取用户ip信息
export function get_userCountry(config?) {
  return Axios.get(URL + `user/country`, config);
}